import { useEffect } from 'react';

/**
 * Known localStorage keys used by the app's services.
 * When a storage event fires for one of these keys (from another tab),
 * the provided callback is invoked with the key name.
 */
const WATCHED_KEYS = new Set([
  'anojeje_events',
  'anojeje_guests',
  'anojeje_tasks',
  'anojeje_wedding_budget',
  'anojeje_fabrics',
  'anojeje_fabric_assignments',
  'anojeje_guidelines',
  'anojeje_calendar_events',
]);

/**
 * Listens for cross-tab `storage` events on known Anojeje localStorage keys.
 * When a change is detected in another tab, calls `onSync(key)`.
 *
 * The `storage` event only fires in *other* tabs/windows — never in the tab
 * that performed the write — so this is safe from infinite loops.
 */
export function useStorageSync(onSync: (key: string) => void): void {
  useEffect(() => {
    const handler = (event: StorageEvent) => {
      if (event.key && WATCHED_KEYS.has(event.key)) {
        onSync(event.key);
      }
    };

    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [onSync]);
}
